import React from 'react';
import PropTypes from 'prop-types';

import {Provider} from 'react-redux';

import {Router, applyRouterMiddleware} from 'react-router';
import {useScroll} from 'react-router-scroll';

import routes from '../../routes/routes';


function Root({store, history}) {
  return (
    <Provider store={store}>
      <Router
        history={history}
        routes={routes}
        render={process.env.CLIENT ? applyRouterMiddleware(useScroll()) : undefined}
      />
    </Provider>
  );
}

Root.propTypes = {
  store: PropTypes.object.isRequired,
  history: PropTypes.object.isRequired
};

export default Root;



// WEBPACK FOOTER //
// ./containers/root/Root.js